import { Injectable } from '@angular/core';
import { environment } from '@/environments/environment';
import axios from 'axios';
import { ToastService } from '../script/toast.service';
import { LoaderService } from '@/app/services/interceptor/loader-service';
import { OrganismResponse } from '@/app/interfaces/organism';

@Injectable({
  providedIn: 'root',
})
export class OrganismService {
  private readonly apiUrl = '/api/aurora';

  constructor(
    private toastService: ToastService,
    private loader: LoaderService
  ) {}

  async getOrganism(): Promise<OrganismResponse> {
    try {
      this.loader.show();

      const response = await axios.post<OrganismResponse>(
        `${environment.url}${this.apiUrl}/filtros`,
        { filter: 'org' },
        { withCredentials: true }
      );
      return response.data;
    } catch (error) {
      this.toastService.showError(
        'Error al obtener los organismos',
        error?.response?.data?.message || 'Ha ocurrido un error inesperado'
      );
      throw error;
    } finally {
      this.loader.hide();
    }
  }
}
